"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var wallet_1 = require("../../../actions/wallet");

var Svg_1 = __importDefault(require("../../Svg"));

var mapStateToProps = function mapStateToProps(state) {
  var WalletState = state.WalletReducer;
  return {
    walletTranslations: WalletState.get("walletTranslations")
  };
};

var AddFunds = function (_super) {
  __extends(AddFunds, _super);

  function AddFunds() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AddFunds.prototype.render = function () {
    var _this = this;

    var walletTranslations = this.props.walletTranslations;
    return React.createElement("div", {
      className: "HydroSDK-addFunds"
    }, React.createElement("div", {
      className: "HydroSDK-buttonGroup"
    }, React.createElement("a", {
      href: "https://www.coinbase.com",
      target: "_blank",
      rel: "noopener noreferrer"
    }, React.createElement("div", {
      className: "button coinbase"
    }, React.createElement(Svg_1.default, {
      name: "Coinbase"
    }))), React.createElement("a", {
      href: "https://gemini.com/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, React.createElement("div", {
      className: "button gemini"
    }, React.createElement(Svg_1.default, {
      name: "Gemini"
    })))), React.createElement("div", {
      className: "HydroSDK-desc"
    }, walletTranslations.addFundsDesc), React.createElement("button", {
      className: "HydroSDK-button HydroSDK-submitButton HydroSDK-featureButton",
      onClick: function onClick() {
        return _this.props.dispatch(wallet_1.setWalletStep(wallet_1.WALLET_STEPS.SELECT));
      }
    }, walletTranslations.done));
  };

  return AddFunds;
}(React.PureComponent);

exports.default = react_redux_1.connect(mapStateToProps)(AddFunds);